import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  max-width: 1300px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

export const Undraw = styled.img`
  height: 350px;
  width: 500px;

  @media (max-width: 1024px) {
    display: none;
  }
`;
